import { useRef, useEffect } from 'react';
import { create } from './useStaffCard.utils/create';
import { staffCardLoader } from './useStaffCard.loaders/staff-card';
import { staffLiteCardLoader } from './useStaffCard.loaders/staff-lite-card';
import { canUseDOM } from '../utils/canUseDOM';
/**
 * Хук для добавления Staff карточки к элементу.
 */
export const useStaffCard = ({ anchorRef, login, uid, env = 'yateam', from, staffOrigin, theme, status, fields, gaps, current, buttons, extras }, active = true) => {
    const cardRef = useRef();
    useEffect(() => {
        if (!canUseDOM()) {
            return;
        }
        if (!active && cardRef.current && typeof cardRef.current.destruct === 'function') {
            cardRef.current.destruct();
            return;
        }
        const loader = env === 'yateam' ? staffCardLoader() : staffLiteCardLoader(staffOrigin);
        loader.then(() => {
            // Прерываем инициализацию карточки если произошел unmount компонента
            if (!anchorRef.current || !active) {
                return;
            }
            if (cardRef.current && 'destroy' in cardRef.current && typeof cardRef.current.destroy === 'function') {
                cardRef.current.destroy();
            }
            cardRef.current = create(anchorRef.current, {
                login,
                uid,
                from,
                theme,
                status,
                fields,
                gaps,
                current,
                buttons,
                extras
            });
        });
        return () => {
            if (cardRef.current && typeof cardRef.current.destruct === 'function') {
                cardRef.current.destruct();
            }
        };
    }, [anchorRef, login, uid, env, from, staffOrigin, active]);
};
